export default {
  install(Vue) {
    Vue.prototype.$isAgent = function() {
      const host = window.location.hostname.split(".")[0];
      return host === "agent" || host === "homolog-agent";
      // return host !== "agent"; // AGENT DEVELOPMENT MODE.
    };
  },
};
